require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./calculators-should-i-consolidate-my-debts.json") })
        }
      }, "path---calculators-should-i-consolidate-my-debts");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---calculators-should-i-consolidate-my-debts!./.cache/json/calculators-should-i-consolidate-my-debts.json
// module id = 1978
// module chunks = 231608221292675